var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import * as _ from 'lodash';
import Multiselect from 'vue-multiselect';
import gql from 'graphql-tag';
import { CARRIERS, COMPANIES, LOCATIONS, PRODUCTS, SILOS } from '@/queries/admin';
import { verifyBolForm, fixBolDate, setBolDate, addSilo, removeSilo, cleanBol } from '@/services/sharedForm';
import { exportBolPdf } from '@/services/importExport';
var sleep = function (m) { return new Promise(function (r) { return setTimeout(r, m); }); };
var EditBOL = /** @class */ (function (_super) {
    __extends(EditBOL, _super);
    function EditBOL() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.bolObj = {};
        _this.origBol = {};
        _this.isSaving = false;
        _this.isEditing = true;
        _this.pdfLoading = false;
        _this.bolLoading = false;
        _this.showHalliburtonFields = false;
        _this.useAutoBol = [];
        _this.isGoodrich = process.env.HASURA_BASE_URL.indexOf('wright') === -1;
        _this.halliburtonSites = [];
        _this.silos = [];
        _this.products = [];
        _this.companies = [];
        _this.carriers = [];
        _this.locations = [];
        _this.availableSilos = [];
        _this.availableSandTypes = [];
        _this.splitLoad = addSilo;
        _this.removeSplitLoad = removeSilo;
        return _this;
    }
    EditBOL.prototype.metaInfo = function () {
        return {
            title: 'Edit BOL'
        };
    };
    EditBOL.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, e_1, bolSub;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$apollo.query({
                                query: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["query ($id: Int!) {\n          bols(where: {id: {_eq: $id}}) {\n            bill_of_lading\n            carrier\n            customer\n            date\n            desired_weight\n            driver_name\n            halliburton_location\n            halliburton_po\n            halliburton_ticket\n            halliburton_tms\n            halliburton_trans_id\n            invoice_num\n            loading_operator\n            location\n            pick_up_num\n            po_num\n            product\n            tare_weight\n            truck_num\n            weights (order_by: {uuid: asc}) {\n              net_weight\n              silo\n              uuid\n            }\n            updates(order_by: {when: asc}, limit: 1) {\n              when\n            }\n          }\n        }"], ["query ($id: Int!) {\n          bols(where: {id: {_eq: $id}}) {\n            bill_of_lading\n            carrier\n            customer\n            date\n            desired_weight\n            driver_name\n            halliburton_location\n            halliburton_po\n            halliburton_ticket\n            halliburton_tms\n            halliburton_trans_id\n            invoice_num\n            loading_operator\n            location\n            pick_up_num\n            po_num\n            product\n            tare_weight\n            truck_num\n            weights (order_by: {uuid: asc}) {\n              net_weight\n              silo\n              uuid\n            }\n            updates(order_by: {when: asc}, limit: 1) {\n              when\n            }\n          }\n        }"]))),
                                variables: {
                                    id: this.$route.params.id
                                },
                                fetchPolicy: 'no-cache'
                            })];
                    case 1:
                        res = _a.sent();
                        if (res.data.bols.length) {
                            this.bolObj = setBolDate(res.data.bols[0]);
                            this.origBol = _.cloneDeep(this.bolObj);
                        }
                        else {
                            this.$router.push({ name: '404' });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.$router.push({ name: '404' });
                        return [3 /*break*/, 3];
                    case 3:
                        bolSub = this.$apollo.subscribe({
                            query: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["subscription ($id: Int!) {\n        bols (where: {id: {_eq: $id}}) {\n          bill_of_lading\n        }\n      }"], ["subscription ($id: Int!) {\n        bols (where: {id: {_eq: $id}}) {\n          bill_of_lading\n        }\n      }"]))),
                            variables: {
                                id: this.$route.params.id
                            },
                            fetchPolicy: 'no-cache'
                        });
                        bolSub.subscribe({
                            next: function (data) {
                                try {
                                    var bolNum = data.data.bols[0].bill_of_lading;
                                    if (bolNum && !_this.bolObj.bill_of_lading) {
                                        _this.bolObj.bill_of_lading = bolNum;
                                        _this.origBol.bill_of_lading = bolNum;
                                    }
                                }
                                catch (e) {
                                    console.log(e);
                                }
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(EditBOL.prototype, "locationObj", {
        get: function () {
            var _this = this;
            return _.find(this.locations, function (location) { return location.name === _this.bolObj.location; });
        },
        set: function (location) {
            (location && location.name) ? this.bolObj.location = location.name : this.bolObj.location = '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditBOL.prototype, "carrierObj", {
        get: function () {
            var _this = this;
            return _.find(this.carriers, function (carrier) { return carrier.name === _this.bolObj.carrier; });
        },
        set: function (carrier) {
            (carrier && carrier.name) ? this.bolObj.carrier = carrier.name : this.bolObj.carrier = '';
        },
        enumerable: true,
        configurable: true
    });
    EditBOL.prototype.changeOptions = function () { };
    EditBOL.prototype.toggleHalliburtonFields = function () { };
    EditBOL.prototype.createBOL = function () {
        return __awaiter(this, void 0, void 0, function () {
            var saveBOL, cleanedBol, removeWeights_2, updateWeights_2, addWeights_1, cloneWeights_1, _i, updateWeights_1, silo, _a, removeWeights_1, uuid, res, e_2;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.isSaving) {
                            return [2 /*return*/];
                        }
                        if (!verifyBolForm(this.bolObj)) {
                            this.$toast.open({
                                duration: 5000,
                                message: 'Please check to make sure the form is filled out properly.',
                                position: 'is-top',
                                type: 'is-warning'
                            });
                            return [2 /*return*/];
                        }
                        if (!this.$route.params.id) {
                            this.$toast.open({
                                duration: 5000,
                                message: 'Please refresh the page before editing this BOL.',
                                position: 'is-top',
                                type: 'is-warning'
                            });
                            return [2 /*return*/];
                        }
                        this.isSaving = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 15, , 16]);
                        return [4 /*yield*/, fixBolDate(this.bolObj, true)];
                    case 2:
                        saveBOL = _b.sent();
                        cleanedBol = cleanBol(saveBOL);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["mutation ($id: Int!, $changes: bols_set_input) {\n          update_bols (\n            where: {id: {_eq: $id}},\n            _set: $changes\n          ) {\n            affected_rows\n          }\n        }"], ["mutation ($id: Int!, $changes: bols_set_input) {\n          update_bols (\n            where: {id: {_eq: $id}},\n            _set: $changes\n          ) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    id: this.$route.params.id,
                                    changes: cleanedBol,
                                }
                            })];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["mutation ($id: Int!, $who: String, $when: timestamptz) {\n          insert_bol_updates (\n            objects: [\n              {\n                bol_id: $id,\n                email: $who,\n                type: \"Update\",\n                when: $when,\n              }\n            ]\n          ) {\n            affected_rows\n          }\n        }"], ["mutation ($id: Int!, $who: String, $when: timestamptz) {\n          insert_bol_updates (\n            objects: [\n              {\n                bol_id: $id,\n                email: $who,\n                type: \"Update\",\n                when: $when,\n              }\n            ]\n          ) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    id: this.$route.params.id,
                                    who: saveBOL.updated_by,
                                    when: saveBOL.updated_at
                                }
                            })];
                    case 4:
                        _b.sent();
                        removeWeights_2 = [];
                        updateWeights_2 = [];
                        addWeights_1 = [];
                        cloneWeights_1 = _.cloneDeep(saveBOL.weights);
                        _.forEach(cloneWeights_1, function (silo, index) {
                            var originalSilo = _this.origBol.weights[index];
                            if (!silo.uuid) {
                                addWeights_1.push({
                                    bol_id: _this.$route.params.id,
                                    silo: silo.silo,
                                    net_weight: silo.net_weight,
                                });
                                if (originalSilo && !_.find(cloneWeights_1, { uuid: originalSilo.uuid })) {
                                    removeWeights_2.push(originalSilo.uuid);
                                }
                                return;
                            }
                            if (originalSilo) {
                                if (originalSilo.uuid !== silo.uuid && !_.find(cloneWeights_1, { uuid: originalSilo.uuid })) {
                                    removeWeights_2.push(originalSilo.uuid);
                                }
                                else {
                                    // Always update if it was pushed up the stack, jic
                                    updateWeights_2.push({
                                        silo: silo.silo,
                                        net_weight: silo.net_weight,
                                        uuid: silo.uuid
                                    });
                                }
                            }
                        });
                        _.forEach(this.origBol.weights, function (silo) {
                            var newSilo = _.find(cloneWeights_1, { uuid: silo.uuid });
                            if (!newSilo) {
                                // An old silo was removed
                                removeWeights_2.push(silo.uuid);
                            }
                        });
                        removeWeights_2 = _.compact(_.uniq(removeWeights_2));
                        _i = 0, updateWeights_1 = updateWeights_2;
                        _b.label = 5;
                    case 5:
                        if (!(_i < updateWeights_1.length)) return [3 /*break*/, 8];
                        silo = updateWeights_1[_i];
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["mutation ($uuid: uuid!, $object: bol_weights_set_input!) {\n            update_bol_weights(where: {uuid: {_eq: $uuid}}, _set: $object) {\n              affected_rows\n            }\n          }"], ["mutation ($uuid: uuid!, $object: bol_weights_set_input!) {\n            update_bol_weights(where: {uuid: {_eq: $uuid}}, _set: $object) {\n              affected_rows\n            }\n          }"]))),
                                variables: {
                                    uuid: silo.uuid,
                                    object: silo
                                }
                            })];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7:
                        _i++;
                        return [3 /*break*/, 5];
                    case 8:
                        _a = 0, removeWeights_1 = removeWeights_2;
                        _b.label = 9;
                    case 9:
                        if (!(_a < removeWeights_1.length)) return [3 /*break*/, 12];
                        uuid = removeWeights_1[_a];
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["mutation ($uuid: uuid!) {\n            delete_bol_weights(where: {uuid: {_eq: $uuid}}) {\n              affected_rows\n            }\n          }"], ["mutation ($uuid: uuid!) {\n            delete_bol_weights(where: {uuid: {_eq: $uuid}}) {\n              affected_rows\n            }\n          }"]))),
                                variables: {
                                    uuid: uuid
                                }
                            })];
                    case 10:
                        _b.sent();
                        _b.label = 11;
                    case 11:
                        _a++;
                        return [3 /*break*/, 9];
                    case 12: return [4 /*yield*/, this.$apollo.mutate({
                            mutation: gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["mutation ($objects: [bol_weights_insert_input!]!) {\n          insert_bol_weights(objects: $objects) {\n            returning {\n              uuid\n              silo\n              net_weight\n            }\n          }\n        }"], ["mutation ($objects: [bol_weights_insert_input!]!) {\n          insert_bol_weights(objects: $objects) {\n            returning {\n              uuid\n              silo\n              net_weight\n            }\n          }\n        }"]))),
                            variables: {
                                objects: addWeights_1
                            }
                        })];
                    case 13:
                        _b.sent();
                        return [4 /*yield*/, this.$apollo.query({
                                query: gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["query ($id: Int) {\n          bol_weights(where: {bol_id: {_eq: $id}}, order_by: {uuid: asc}) {\n            uuid\n            silo\n            net_weight\n          }\n        }"], ["query ($id: Int) {\n          bol_weights(where: {bol_id: {_eq: $id}}, order_by: {uuid: asc}) {\n            uuid\n            silo\n            net_weight\n          }\n        }"]))),
                                variables: {
                                    id: this.$route.params.id
                                },
                                fetchPolicy: 'no-cache'
                            })];
                    case 14:
                        res = _b.sent();
                        saveBOL.weights = res.data.bol_weights;
                        this.bolObj.weights = res.data.bol_weights;
                        this.origBol = _.cloneDeep(saveBOL);
                        this.$toast.open({
                            duration: 5000,
                            message: 'Successfully updated BOL.',
                            position: 'is-top',
                            type: 'is-success'
                        });
                        return [3 /*break*/, 16];
                    case 15:
                        e_2 = _b.sent();
                        console.log(e_2);
                        this.$toast.open({
                            duration: 5000,
                            message: 'There was an error updating BOL. Please try again.',
                            position: 'is-top',
                            type: 'is-danger'
                        });
                        return [3 /*break*/, 16];
                    case 16:
                        this.isSaving = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    EditBOL.prototype.deleteBOL = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isSaving = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_9 || (templateObject_9 = __makeTemplateObject(["mutation ($id: Int!) {\n          delete_bol_weights(where: {bol_id: {_eq: $id}}) {\n            affected_rows\n          }\n        }"], ["mutation ($id: Int!) {\n          delete_bol_weights(where: {bol_id: {_eq: $id}}) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    id: this.$route.params.id,
                                }
                            })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_10 || (templateObject_10 = __makeTemplateObject(["mutation ($id: Int!) {\n          delete_bol_updates(where: {bol_id: {_eq: $id}}) {\n            affected_rows\n          }\n        }"], ["mutation ($id: Int!) {\n          delete_bol_updates(where: {bol_id: {_eq: $id}}) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    id: this.$route.params.id,
                                }
                            })];
                    case 3:
                        _a.sent();
                        // Stupid hack
                        // Wait for webhooks to run before nuking BOL
                        return [4 /*yield*/, sleep(4000)];
                    case 4:
                        // Stupid hack
                        // Wait for webhooks to run before nuking BOL
                        _a.sent();
                        return [4 /*yield*/, this.$apollo.mutate({
                                mutation: gql(templateObject_11 || (templateObject_11 = __makeTemplateObject(["mutation ($id: Int!) {\n          delete_bols(where: {id: {_eq: $id}}) {\n            affected_rows\n          }\n        }"], ["mutation ($id: Int!) {\n          delete_bols(where: {id: {_eq: $id}}) {\n            affected_rows\n          }\n        }"]))),
                                variables: {
                                    id: this.$route.params.id,
                                }
                            })];
                    case 5:
                        _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'Successfully removed BOL.',
                            position: 'is-top',
                            type: 'is-success'
                        });
                        this.$router.push({ name: 'Home Redirect' });
                        return [3 /*break*/, 7];
                    case 6:
                        e_3 = _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'Could not delete BOL. Please try again.',
                            position: 'is-top',
                            type: 'is-warning'
                        });
                        return [3 /*break*/, 7];
                    case 7:
                        this.isSaving = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    EditBOL.prototype.openSockModal = function (location) {
        var _this = this;
        this.$dialog.confirm({
            title: 'SOCK Status',
            message: '<b>AUTO UP on the SOCK</b>',
            type: 'is-danger',
            hasIcon: true,
            onConfirm: function () { return _this.printBOL(location); }
        });
    };
    EditBOL.prototype.printBOL = function (location) {
        return __awaiter(this, void 0, void 0, function () {
            var res, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!verifyBolForm(this.origBol)) {
                            this.$toast.open({
                                duration: 5000,
                                message: 'Please check to make sure the form is filled out properly.',
                                position: 'is-top',
                                type: 'is-warning'
                            });
                            return [2 /*return*/];
                        }
                        this.pdfLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        if (!!this.origBol.bill_of_lading) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.$apollo.query({
                                query: gql(templateObject_12 || (templateObject_12 = __makeTemplateObject(["query ($id: Int!) {\n            bols(where: {id: {_eq: $id}}) {\n              bill_of_lading\n            }\n          }"], ["query ($id: Int!) {\n            bols(where: {id: {_eq: $id}}) {\n              bill_of_lading\n            }\n          }"]))),
                                variables: {
                                    id: this.$route.params.id
                                },
                                fetchPolicy: 'no-cache'
                            })];
                    case 2:
                        res = _a.sent();
                        this.origBol.bill_of_lading = res.data.bols[0].bill_of_lading;
                        _a.label = 3;
                    case 3:
                        exportBolPdf(this.origBol, location);
                        return [3 /*break*/, 5];
                    case 4:
                        e_4 = _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'There was an issue creating the PDF. Please try again.',
                            position: 'is-top',
                            type: 'is-danger'
                        });
                        return [3 /*break*/, 5];
                    case 5:
                        this.pdfLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    EditBOL.prototype.deleteDialog = function () {
        var _this = this;
        this.$dialog.confirm({
            title: 'Deleting BOL',
            message: 'Are you sure you want to <b>delete</b> this BOL? This action cannot be undone.',
            confirmText: 'Delete BOL',
            type: 'is-danger',
            hasIcon: true,
            onConfirm: function () { return _this.deleteBOL(); }
        });
    };
    EditBOL = __decorate([
        Component({
            name: 'edit-bol',
            components: { Multiselect: Multiselect },
            apollo: {
                carriers: {
                    query: function () { return CARRIERS; },
                    fetchPolicy: 'no-cache'
                },
                companies: {
                    query: function () { return COMPANIES; },
                    fetchPolicy: 'no-cache'
                },
                locations: {
                    query: function () { return LOCATIONS; },
                    fetchPolicy: 'no-cache'
                },
                products: {
                    query: function () { return PRODUCTS; },
                    fetchPolicy: 'no-cache',
                    result: function (_a) {
                        var data = _a.data;
                        this.availableSandTypes = data.products;
                    }
                },
                silos: {
                    query: function () { return SILOS; },
                    fetchPolicy: 'no-cache',
                    result: function (_a) {
                        var data = _a.data;
                        this.availableSilos = data.silos;
                    }
                }
            }
        })
    ], EditBOL);
    return EditBOL;
}(Vue));
export default EditBOL;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditBOL.vue
// module id = 781
// module chunks = 1